import React from 'react';
import './Button.scss';
import { useDirtyWarningContext, DirtyWarningConfirmProps } from '../../DirtyWarning/DirtyWarningContext';

export interface ButtonProps extends DirtyWarningConfirmProps {
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    color?: 'default' | 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'link' | 'none';
    disabled?: boolean;
    showFeedback?: boolean;
    type?: 'button' | 'reset' | 'submit';
    className?: string;
    name?: string;
    ref?: React.RefObject<HTMLButtonElement>;    
}

export const Button: React.FC<ButtonProps> = (props) => {    
    const resetDirtyTracking = props.resetDirtyTracking || false;
    const showDirtyWarning = props.showDirtyWarning || false;    
    const context = useDirtyWarningContext();

    const proceedWithUnsavedChanges = async function() {
        return !context.dirty || await context.confirm(props.dirtyWarningMessage);
    }

    const handleClick = async function(e: React.MouseEvent<any>) {
        e.preventDefault();  

        const proceed = showDirtyWarning ? await proceedWithUnsavedChanges() : true;
        if (proceed) {
            if (props.onClick) props.onClick(e);
            if (resetDirtyTracking) context.setDirty(false);
        }
    };
     
    const handleSubmit = async function(e: React.FormEvent<any>) { 
        e.preventDefault();

        const proceed = showDirtyWarning ? await proceedWithUnsavedChanges() : true;
        if (proceed) {
            if (props.onSubmit) props.onSubmit(e);
            if (resetDirtyTracking) context.setDirty(false);
        }
    };

    let handlers: any = {}
    let btnType = props.type || 'button';
    if (btnType === 'submit') handlers.onSubmit = handleSubmit;
    else if (btnType === 'button') handlers.onClick = handleClick;

    const disabled = props.disabled || false;
    const btnColor = props.color || 'primary';
    let css = `btn`;
    if (btnColor !== "none") {
        css += ` btn-${btnColor}`;
    } 

    if (props.className) {
        css += ' ' + props.className;
    }

    return (
        <button className={css} 
                disabled={disabled} 
                type={btnType}
                name={props.name}
                ref={props.ref}
                {...handlers}>
            {props.children}
        </button>
    );
}

(Button as any).displayName = 'Button';